import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useApi } from 'stores/api';

const ResetPassword = (props) => {
    const api = useApi();
    const { t } = useTranslation(['password-reset']);

    const qsp = new URLSearchParams(document.location.search);
    const username = qsp.get("userName") || '';
    const token = qsp.get("token") || '';

    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState({
        password1: '',
        password2: ''
    });
    const [resetSuccess, setResetSuccess] = useState(false);

    const setField = (field, value) => {
        setFields({
            ...fields,
            [field]: value
        })
    }

    const setNewPassword = async (e) => {
        e.preventDefault()
        const newErrors = findFormErrors();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        } else {
            let result = await api.resetPassword({
                username, token, newPassword: fields.password1, confirmPassword: fields.password2
            });
            if (result) {
                setResetSuccess(true);
            }
        }
    }

    const findFormErrors = () => {
        const { password1, password2 } = fields;
        const newErrors = {};
 
        if (!password1 || password1 === '') newErrors.password1 = 'password1 cannot be empty!';
        if (!password2 || password2 === '') newErrors.password2 = 'password2 cannot be empty!';

        return newErrors;
    }

    return (
        <>
            {!resetSuccess && <section className="passwordForgotten-container">
                <div className="wrapper">
                    <div className="row">
                        <div className="column-12">
                            <h3 className="mali-blue">{t("resetPassword")}</h3>
                            <div className="password-container">
                                <div className="row">
                                    <h4>{t("enterNewPassword")}</h4>
                                </div>
                                <div className="row">
                                    <div className="label">
                                        {t("username")}
                                    </div>
                                    <div className="input">
                                        <input type="text" disabled value={username} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="label">
                                        {t("newPassword")}
                                    </div>
                                    <div className="input">
                                        <input type="password" value={fields.password1} onChange={e => setField('password1', e.target.value)} />
                                    </div>
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.password1}
                                    </Form.Control.Feedback>                                    
                                    <p className="password-tip small">{t("passwordComplexityDesc")}</p>
                                </div>
                                <div className="row">
                                    <div className="label">
                                        {t("repeatNewPassword")}
                                    </div>
                                    <div className="input">
                                        <input type="password" value={fields.password2} onChange={e => setField('password2', e.target.value)} />
                                    </div>
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.password2}
                                    </Form.Control.Feedback>                                      
                                </div>
                                <div className="row passwordForgottenBtns-container">
                                    <a className="forward" onClick={setNewPassword}>{t("savePassword")} <i className="fa fa-floppy-o" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>}

            {resetSuccess && <section className="passwordForgotten-container">
                <div className="wrapper">
                    <div className="row">
                        <div className="column-12">
                            <h3 className="mali-blue">{t("resetSuccessTitle")}</h3>
                            <div className="password-container">
                                <div className="row">
                                    <h4>{t("resetSuccessDesc")}</h4>
                                </div>
                                <div className="row passwordForgottenBtns-container">
                                    <Link className="forward" to="/">
                                        {t("goHome")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    );
}

export default ResetPassword;